// Environment configuration
// These functions are evaluated at RUNTIME, not build time, to support dynamic hostnames

export const getApiUrl = () => {
  // Debug logging
  console.log('🔍 Environment Debug:', {
    hostname: window.location.hostname,
    protocol: window.location.protocol,
    port: window.location.port,
    href: window.location.href,
    reactAppApiUrl: process.env.REACT_APP_API_URL
  });
  
  // Check for explicit API URL from environment variable (set at build time)
  if (process.env.REACT_APP_API_URL) {
    console.log('🌐 Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  
  // In development (localhost), use backend directly on port 5001
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.')) {
    const apiUrl = 'http://localhost:5001';
    console.log('🌐 Using localhost backend:', apiUrl);
    return apiUrl;
  }
  
  // In production, use current origin (assumes API is proxied or on same host)
  const apiUrl = `${window.location.protocol}//${window.location.host}`;
  console.log('🌐 Using current origin for API:', apiUrl);
  return apiUrl;
};

export const getFrontendUrl = () => {
  return `${window.location.protocol}//${window.location.hostname}`;
};

export const getEnvironment = () => {
  return process.env.NODE_ENV || 'development';
};

// Build timestamp for cache busting
export const BUILD_TIMESTAMP = Date.now();
export const BUILD_VERSION = '1.0.2-no-port-in-api-url';

export default {
  getApiUrl,
  getFrontendUrl,
  getEnvironment
};
// Cache bust Sat Oct 11 22:35:04 EDT 2025
